import {Input, OnDestroy, OnInit} from '@angular/core';
import {FormArray, FormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';

/**
 * Поля визарда являются вложенными формами.
 * Изначально вложенные формы были реализованы в AbstractFields и затем вынесены в SubFormComponent,
 * но завязка на AbstractFields в визарде много где осталась, поэтому я решил пока оставить такую транзитивность
 * */

export class AbstractFields implements OnInit, OnDestroy {

    @Input() form: FormGroup;

    /**
     * Работал ли уже пользователь с этой вложенной формой?
     * @returns {boolean}
     */

    protected subs: Subscription[] = [];
    public isFormTouched() {
        return this.form && this.form.get('_touched') && this.form.get('_touched').value === true;
    }

    ngOnInit() {

    }

    public removeSelf() {
        const parent = this.form.parent;

        if (!(parent instanceof FormArray)) {
            return;
        }

        const index = parent.controls.indexOf(this.form);

        parent.removeAt(index);
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs.length = 0;
    }
}
